/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { IonCol } from '@ionic/react';
import { S3_PROFILE_BASE as S3_BASE } from 'common/common';
import { LeaderboardPlayerName } from 'pages/LeaderBoardTab/PrivateLeaderboardPlayerLabel';
import './userBadge.scss';
import '../../pages/LeaderBoardTab/views/Leaderboard/leaderboard.scss';

interface UserBadgeProps {
  aliasName: string;
  aliasInitial: string;
  playerCircleCls?: string;
  avatarId?: number;
  avatarBgId?: number;
}

const UserBadge: React.FC<UserBadgeProps> = ({
  aliasName,
  aliasInitial,
  playerCircleCls = 'user-avatar-color5',
  avatarId,
  avatarBgId,
}) => {
  return (
    <IonCol size="7" class="center-flex-align">
      <div className="table-data-flex-container player-name-container">
        {avatarId ? (
          <span
            className="player-alias-box player-alias-box--avatar"
            style={{ backgroundImage: `url(${S3_BASE}/avatar-bg${avatarBgId}.png)` }}
          >
            <img
              src={`${S3_BASE}/avatar${avatarId}.png`}
              alt={aliasName}
              className="player-alias-box__avatar-img"
            />
          </span>
        ) : (
          <span className={`player-alias-box ${playerCircleCls}`}>
            {aliasInitial}
          </span>
        )}
        <LeaderboardPlayerName name={aliasName} className="player-alias-name" />
      </div>
    </IonCol>
  );
};

export default UserBadge;
